import { render, staticRenderFns } from "./ReferalLogs.vue?vue&type=template&id=d2fa88fc&scoped=true"
import script from "./ReferalLogs.vue?vue&type=script&lang=js"
export * from "./ReferalLogs.vue?vue&type=script&lang=js"
import style0 from "./ReferalLogs.vue?vue&type=style&index=0&id=d2fa88fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2fa88fc",
  null
  
)

export default component.exports